import { NavContextType } from "src/components/navigation/NavContext"
import { Portal } from "src/components/navigation/Portal"
import { SuperAdminBookingLayout } from "src/components/superadmin/bookings/SuperAdminBookingLayout";
import { SuperAdminTenantBreadCrumb } from "src/components/superadmin/tenants/SuperAdminTenantBreadcrumb";
import { SuperAdminTenantLayout } from "src/components/superadmin/tenants/SuperAdminTenantLayout";
import { Icons } from "src/components/ui/Icons"

import { NotFound } from "src/screens/global/NotFound";

import { SuperAdminBooking } from "src/screens/superadmin/bookings/SuperAdminBooking";
import { SuperAdminBookings } from "src/screens/superadmin/bookings/SuperAdminBookings";

import { SuperAdminTenant } from "src/screens/superadmin/tenants/SuperAdminTenant";
import { SuperAdminTenants } from "src/screens/superadmin/tenants/SuperAdminTenants";
import { SuperAdminHome } from "src/screens/superadmin/SuperAdminHome";

import { SuperAdminUsers } from "src/screens/superadmin/users/SuperAdminUsers";

import { SuperAdminVenue } from "src/screens/superadmin/venues/SuperAdminVenue";
import { SuperAdminVenues } from "src/screens/superadmin/venues/SuperAdminVenues";
import { SuperAdminVenueLayout } from "src/components/superadmin/venues/SuperAdminVenueLayout";
import { SuperAdminVenueBreadCrumb } from "src/components/superadmin/venues/SuperAdminVenueBreadcrumb";
import { SuperAdminVenueUsers } from "src/screens/superadmin/venues/users/SuperAdminVenueUsers";
import { SuperAdminVenueAreaBreadCrumb } from "src/components/superadmin/venues/areas/SuperAdminVenueAreaBreadcrumb";
import { SuperAdminVenueAreaLayout } from "src/components/superadmin/venues/areas/SuperAdminVenueAreaLayout";
import { SuperAdminVenueAreas } from "src/screens/superadmin/venues/areas/SuperAdminVenueAreas";
import { SuperAdminVenueGuidelines } from "src/screens/superadmin/venues/guidelines/SuperAdminVenueGuidelines";
import { SuperAdminVenueAreaGuidelines } from "src/screens/superadmin/venues/areas/guidelines/SuperAdminVenueAreaGuidelines";
import { SuperAdminVenueBookings } from "src/screens/superadmin/venues/bookings/SuperAdminVenueBookings";
import { SuperAdminTalents } from "src/screens/superadmin/talent/SuperAdminTalents";
import { AppShellLayout } from "src/components/ui/AppShellLayout";
import { RouteDrawer } from "src/components/navigation/RouteDrawer";
import { SuperAdminVenueAreaOverlay } from "src/screens/superadmin/venues/areas/SuperAdminVenueAreaOverlay";
import { SuperAdminVenueAreaGuidelinesOverlay } from "src/screens/superadmin/venues/areas/guidelines/SuperAdminVenueAreaGuidelinesOverlay";
import { SuperAdminVenueArea } from "src/screens/superadmin/venues/areas/SuperAdminVenueArea";
import { SuperAdminVenueBookingLayout } from "src/components/superadmin/venues/bookings/SuperAdminVenueBookingLayout";
import { SuperAdminVenueBooking } from "src/screens/superadmin/venues/bookings/SuperAdminVenueBooking";
import { SuperAdminVenueBookingBreadCrumb } from "src/components/superadmin/venues/bookings/SuperAdminVenueBookingBreadcrumb";
import { SuperAdminVenueBookingOverlay } from "src/screens/superadmin/venues/bookings/SuperAdminVenueBookingOverlay";
import { SuperAdminVenueBookingGuidelines } from "src/screens/superadmin/venues/bookings/guidelines/SuperAdminVenueBookingGuidelines";
import { SuperAdminVenueBookingGuidelinesOverlay } from "src/screens/superadmin/venues/bookings/guidelines/SuperAdminVenueBookingGuidelinesOverlay";
import { SuperAdminBookingBreadCrumb } from "src/components/superadmin/bookings/SuperAdminBookingBreadcrumb";
import { SuperAdminBookingOverlay } from "src/screens/superadmin/bookings/SuperAdminBookingOverlay";
import { SuperAdminBookingGuidelines } from "src/screens/superadmin/bookings/guidelines/SuperAdminBookingGuidelines";
import { SuperAdminBookingGuidelinesOverlay } from "src/screens/superadmin/bookings/guidelines/SuperAdminBookingGuidelinesOverlay";
import { SuperAdminTalentLayout } from "src/components/superadmin/talent/SuperAdminTalentLayout";
import { SuperAdminTalent } from "src/screens/superadmin/talent/SuperAdminTalent";
import { SuperAdminTalentBreadCrumb } from "src/components/superadmin/talent/SuperAdminTalentBreadcrumb";
import { SuperAdminTalentGuidelines } from "src/screens/superadmin/talent/guidelines/SuperAdminTalentGuidelines";
import { SuperAdminTalentOverlay } from "src/screens/superadmin/talent/SuperAdminTalentOverlay";
import { SuperAdminTalentGuidelinesOverlay } from "src/screens/superadmin/talent/guidelines/SuperAdminTalentGuidelinesOverlay";
import { SuperAdminThreads } from "src/screens/superadmin/threads/SuperAdminThreads";
import { SuperAdminThreadLayout } from "src/components/superadmin/threads/SuperAdminThreadLayout";
import { SuperAdminThreadBreadCrumb } from "src/components/superadmin/threads/SuperAdminThreadBreadcrumb";
import { SuperAdminThread } from "src/screens/superadmin/threads/SuperAdminThread";
import { SuperAdminThreadOverlay } from "src/screens/superadmin/threads/SuperAdminThreadOverlay";
import { SuperAdminBookingsCalendar } from "src/screens/superadmin/bookings/SuperAdminBookingsCalendar";
import { CalendarPortal } from "src/components/calendar/CalendarPortal";
import { SuperAdminTalentBlackouts } from "src/screens/superadmin/talent/blackouts/SuperAdminTalentBlackouts";
import { SuperAdminTalentBlackoutsOverlay } from "src/screens/superadmin/talent/blackouts/SuperAdminTalentBlackoutsOverlay";
import { SuperAdminTalentDocuments } from "src/screens/superadmin/talent/documents/SuperAdminTalentDocuments";
import { SuperAdminTalentDocumentsOverlay } from "src/screens/superadmin/talent/documents/SuperAdminTalentDocumentsOverlay";
import { UserProfile } from "src/screens/user/UserProfile";
import { SuperAdminTenantUsers } from "src/screens/superadmin/tenants/users/SuperAdminTenantUsers";

export const SuperAdminRoutes = (): NavContextType => ({
    routes: [
        {
            path: '/',
            element: <AppShellLayout />,
            breadcrumb: 'Layout',
            children: [
                { index: true, element: <SuperAdminHome />, breadcrumb: 'Home' },
                { path: "profile", element: <UserProfile />, breadcrumb: 'User Profile' },
                {
                    path: "users",
                    element: <Portal />,
                    breadcrumb: 'Users',
                    children: [
                        { index: true, element: <SuperAdminUsers /> },
                    ]
                },
                {
                    path: "calendar",
                    element: <CalendarPortal />,
                    breadcrumb: 'Calendar',
                    children: [
                        { index: true, element: <SuperAdminBookingsCalendar /> },
                    ]
                },
                {
                    path: "inbox",
                    element: <Portal />,
                    breadcrumb: 'Inbox',
                    children: [
                        { index: true, element: <SuperAdminThreads /> },
                        {
                            path: ":threadId",
                            element: <SuperAdminThreadLayout />,
                            children: [
                                { index: true, element: <SuperAdminThread />, breadcrumb: SuperAdminThreadBreadCrumb }
                            ]
                        }
                    ]
                },
                {
                    path: "talent",
                    element: <Portal />,
                    breadcrumb: 'Talent',
                    children: [
                        { index: true, element: <SuperAdminTalents /> },
                        {
                            path: ":talentId",
                            element: <SuperAdminTalentLayout />,
                            children: [
                                { index: true, element: <SuperAdminTalent />, breadcrumb: SuperAdminTalentBreadCrumb },
                                { path: "guidelines", element: <SuperAdminTalentGuidelines />, breadcrumb: 'Guidelines' },
                                { path: "blackouts", element: <SuperAdminTalentBlackouts />, breadcrumb: 'Blackout Dates' },
                                { path: "documents", element: <SuperAdminTalentDocuments />, breadcrumb: 'Documents' } 
                            ]
                        }
                    ]
                },
                {
                    path: "bookings",
                    element: <Portal />,
                    breadcrumb: "Bookings",
                    children: [
                        { index: true, element: <SuperAdminBookings /> },
                        {
                            path: ":bookingId",
                            element: <SuperAdminBookingLayout />,
                            children: [
                                { index: true, element: <SuperAdminBooking />, breadcrumb: SuperAdminBookingBreadCrumb },
                                { path: "guidelines", element: <SuperAdminBookingGuidelines />, breadcrumb: 'Guidelines' }
                            ]
                        }
                    ]
                },
                {
                    path: "tenants",
                    element: <Portal />,
                    breadcrumb: "Tenants",
                    children: [
                        { index: true, element: <SuperAdminTenants /> },
                        {
                            path: ":id",
                            element: <SuperAdminTenantLayout />,
                            children: [
                                { index: true, element: <SuperAdminTenant />, breadcrumb: SuperAdminTenantBreadCrumb },
                                { path: "users", element: <SuperAdminTenantUsers />, breadcrumb: 'Users' },
                            ]
                        }
                    ]
                },
                {
                    path: "venues",
                    element: <Portal />,
                    breadcrumb: "Venues",
                    children: [
                        { index: true, element: <SuperAdminVenues /> },
                        {
                            path: ":venueId",
                            element: <SuperAdminVenueLayout />,
                            children: [
                                { index: true, element: <SuperAdminVenue />, breadcrumb: SuperAdminVenueBreadCrumb },
                                { path: "users", element: <SuperAdminVenueUsers />, breadcrumb: 'Users' },
                                { path: "guidelines", element: <SuperAdminVenueGuidelines />, breadcrumb: 'Guidelines' },
                                {
                                    path: "bookings",
                                    element: <Portal />,
                                    children: [
                                        { index: true, element: <SuperAdminVenueBookings />, breadcrumb: 'Bookings' },
                                        {
                                            path: ":bookingId",
                                            element: <SuperAdminVenueBookingLayout />,
                                            children: [
                                                { index: true, element: <SuperAdminVenueBooking />, breadcrumb: SuperAdminVenueBookingBreadCrumb },
                                                { path: "guidelines", element: <SuperAdminVenueBookingGuidelines />, breadcrumb: 'Guidelines' }
                                            ]

                                        }
                                    ]
                                },
                                {
                                    path: "areas",
                                    element: <Portal />,
                                    children: [
                                        { index: true, element: <SuperAdminVenueAreas />, breadcrumb: 'Areas' },
                                        {
                                            path: ":areaId",
                                            element: <SuperAdminVenueAreaLayout />,
                                            children: [
                                                { index: true, element: <SuperAdminVenueArea />, breadcrumb: SuperAdminVenueAreaBreadCrumb },
                                                { path: "guidelines", element: <SuperAdminVenueAreaGuidelines />, breadcrumb: 'Guidelines' }
                                            ]

                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                { path: "*", element: <NotFound />, breadcrumb: 'Not Found' }
            ]
        }
    ],
    overlays: [
        {
            path: "/inbox/:threadId",
            element: <RouteDrawer />,
            children: [
                {
                    element: <SuperAdminThreadLayout />,
                    children: [
                        { index: true, element: <SuperAdminThreadOverlay /> }
                    ]
                }
            ],
        },
        {
            path: "/bookings/:bookingId",
            element: <RouteDrawer />,
            children: [
                {
                    element: <SuperAdminBookingLayout />,
                    children: [
                        { index: true, element: <SuperAdminBookingOverlay /> },
                        { path: "guidelines", element: <SuperAdminBookingGuidelinesOverlay /> },
                    ]
                }
            ],
        },
        {
            path: "/talent/:talentId",
            element: <RouteDrawer />,
            children: [
                {
                    element: <SuperAdminTalentLayout />,
                    children: [
                        { index: true, element: <SuperAdminTalentOverlay /> },
                        { path: "guidelines", element: <SuperAdminTalentGuidelinesOverlay /> },
                        { path: "blackouts", element: <SuperAdminTalentBlackoutsOverlay /> },
                        { path: "documents", element: <SuperAdminTalentDocumentsOverlay /> },
                    ]
                }
            ],
        },
        {
            path: "/venues/:venueId/areas/:areaId",
            element: <RouteDrawer />,
            children: [
                {
                    element: <SuperAdminVenueAreaLayout />,
                    children: [
                        { index: true, element: <SuperAdminVenueAreaOverlay /> },
                        { path: "guidelines", element: <SuperAdminVenueAreaGuidelinesOverlay /> },
                    ]
                }
            ],
        },
        {
            path: "/venues/:venueId/bookings/:bookingId",
            element: <RouteDrawer />,
            children: [
                {
                    element: <SuperAdminVenueBookingLayout />,
                    children: [
                        { index: true, element: <SuperAdminVenueBookingOverlay /> },
                        { path: "guidelines", element: <SuperAdminVenueBookingGuidelinesOverlay /> },
                    ]
                }
            ],
        }
    ],
    menu: [
        {
            to: '/',
            label: 'Home',
            icon: Icons.home
        },
        {
            to: '/inbox',
            label: 'Inbox',
            icon: Icons.inbox
        },
        {
            to: '/bookings',
            label: 'Bookings',
            icon: Icons.location
        },
        {
            to: '/calendar',
            label: 'Calendar',
            icon: Icons.calendar
        },
        {
            to: '/venues',
            label: 'Venues',
            icon: Icons.tenants
        },
        {
            to: '/tenants',
            label: 'Tenants',
            icon: Icons.tenants
        },
        {
            to: '/talent',
            label: 'Talent',
            icon: Icons.user
        },
        {
            to: '/users',
            label: 'Users',
            icon: Icons.user
        },
    ],
    mobile: [
        {
            to: '/',
            label: 'Home',
            icon: Icons.home
        },
        {
            to: '/bookings',
            label: 'Bookings',
            icon: Icons.location
        },
        {
            to: '/tenants',
            label: 'Tenants',
            icon: Icons.tenants
        },
        {
            to: '/users',
            label: 'Users',
            icon: Icons.user
        },
    ]
})